import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.PeLiquiditySortEnum>
) {
  const {
    pagination: { page, perPage },
    sort: { field, order },
  } = params;

  const {
    peLiquidityList: { items: data, total },
  } = await sdk.getListPeLiquidity({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage,
    },
    sort: [{ field, order }],
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { peLiquidity: data } = await sdk.getOnePeLiquidity({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const { peLiquidityMany: data } = await sdk.getManyPeLiquidity({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const peLiquidity = types.dataProvider({
  getList,
  getOne,
  getMany,
});
